import { State } from '../state';

export const NavigationSelectors = {
    isDrawerOpen: (state: State): boolean => state.Navigation.drawerOpen,
    isDrawerVariant: (state: State): 'persistent' | 'temporary' | 'permanent' => state.Navigation.drawerVariant,
};
